import {
  AgStepbarItem,
  AgDropMenu,
  AgDropMenuContent
} from '@rededor/ag-shared-components-react'
import { useStepStatus } from '@/hooks/useStepStatus'
import { useScheduleStore } from '@/store/useScheduleStore'
import { useStepAction } from './useStepAction'

export const LocationStep = () => {
  const location = useScheduleStore((state) => state.location)
  const unit = useScheduleStore((state) => state.unit)
  const targetStep = 'location'

  const status = useStepStatus({
    isCompleted: Boolean(location?.id) || Boolean(unit?.id),
    targetPath: '/local',
    targetStep
  })

  const infoLocation = location?.id
    ? `${location?.name} - ${location?.address?.state}`
    : undefined

  const { handleClickAction, handleSelectStep } = useStepAction('/local')

  return (
    <AgStepbarItem
      step="Local"
      info={infoLocation || unit?.name}
      icon="geotag"
      onSelectStep={handleSelectStep}
      status={status}
      targetStep={targetStep}
    >
      <AgDropMenu>
        <AgDropMenuContent
          step="Local"
          info={infoLocation || unit?.name}
          labelAction="Alterar local"
          onClickAction={handleClickAction}
        />
      </AgDropMenu>
    </AgStepbarItem>
  )
}
